import { If } from '@/components/utils/conditionalComponents';
import { ClickHandler, wrapOnClick } from '@/utils/clickEvent';
import { Component, Style } from '@/utils/reactTypes';
import { Box, Fab, useTheme } from '@mui/material';
import { Link } from 'react-router';

// You can float the button to the bottom-right of the screen by setting float={true}, but prefer
//  instead to put the button inside <AxlePageHeader>.
export const FloatingActionButton = ({
    icon = null,
    text = '',
    onClick,
    link,
    float = false,
    fullWidth = false,
    style = {},
}: {
    icon?: Component;
    text?: string;
    onClick?: ClickHandler;
    link?: string;
    float?: boolean;
    fullWidth?: boolean;
    style?: Style;
}) => {
    const theme = useTheme();
    let component = (
        <Fab
            variant={'extended'}
            color={'primary'}
            onClick={wrapOnClick(onClick)}
            sx={{
                ...(fullWidth ? { width: '100%' } : {}),
                ...(float
                    ? {
                          position: 'fixed',
                          bottom: theme.spacing(2),
                          right: theme.spacing(2),
                          zIndex: 2,
                      }
                    : {}),
                borderRadius: '8px',
                padding: '8px',
                height: '40px',
                boxShadow:
                    '0px 3px 5px -1px rgba(0,0,0,0.05),0px 6px 10px 0px rgba(0,0,0,0.07),0px 1px 18px 0px rgba(0,0,0,0.06)',
                ...style,
            }}
        >
            {icon}
            <If condition={!!text}>
                <Box
                    sx={{ marginLeft: 1, whiteSpace: 'nowrap', lineHeight: '1em', marginRight: 1 }}
                >
                    {text}
                </Box>
            </If>
        </Fab>
    );
    if (link) {
        component = <Link to={link}>{component}</Link>;
    }
    return component;
};

export const InvertedFloatingActionButton = ({
    icon = null,
    text = '',
    onClick,
    link,
    float = false,
    fullWidth = false,
    style = {},
}: {
    icon?: Component;
    text?: string;
    onClick?: ClickHandler;
    link?: string;
    float?: boolean;
    fullWidth?: boolean;
    style?: Style;
}) => {
    const theme = useTheme();
    let component = (
        <Fab
            variant={'extended'}
            color={'primary'}
            onClick={wrapOnClick(onClick)}
            sx={{
                ...(fullWidth ? { width: '100%' } : {}),
                ...(float
                    ? {
                          position: 'fixed',
                          bottom: theme.spacing(2),
                          right: theme.spacing(2),
                          zIndex: 2,
                      }
                    : {}),
                backgroundColor: 'white',
                color: '#54BBBD',
                '&:hover': {
                    backgroundColor: '#54BBBD',
                    color: 'white',
                },
                ...style,
                boxShadow: 'none',
                border: '2px solid #54BBBD',
            }}
        >
            {icon}
            <If condition={!!text}>
                <Box
                    sx={{ marginLeft: 1, whiteSpace: 'nowrap', lineHeight: '1em', marginRight: 1 }}
                >
                    {text}
                </Box>
            </If>
        </Fab>
    );
    if (link) {
        component = <Link to={link}>{component}</Link>;
    }
    return component;
};
